/**
 * Shared in-game chrome constants.
 *
 * GAME_TOP_BAR_HEIGHT lives here (not in GameTopBar) so both GameTopBar and the
 * overlays that align to it (PlayerRosterPanel, chat) can
 * import it without a circular dependency.
 */

/** Height of the thin in-game top bar (38px icon + 4px top/bottom padding). */
export const GAME_TOP_BAR_HEIGHT = 46

/** Outer inset for map edge actions, inline chat/log controls and turn panels. */
export const GAME_CONTROL_EDGE_INSET = 8

/** Symmetric space around the Fortify label and its trailing arrow. */
export const FORTIFY_BUTTON_PADDING = 12

/**
 * Portrait game screen: extra space above the top bar's controls so the gap
 * over the player dots matches the gap under them. The snapshot banner (which
 * replaces the bar) and the map's position estimate use the same total.
 */
export const PORTRAIT_GAME_TOP_BAR_PAD = 2
export const PORTRAIT_GAME_TOP_BAR_HEIGHT = GAME_TOP_BAR_HEIGHT + PORTRAIT_GAME_TOP_BAR_PAD

/**
 * Landscape windows at least this tall (desktop browsers, landscape tablets)
 * keep chat + log permanently in the side column; shorter ones (landscape
 * phones) keep the chat/log toggles to save room.
 */
export const PERSISTENT_CHAT_MIN_HEIGHT = 600

/** Height of the branded home header (48px mark + 12px vertical padding). */
export const HOME_HEADER_HEIGHT = 72

/** All non-home navigation rows match the compact game chrome. */
export const STANDARD_HEADER_HEIGHT = GAME_TOP_BAR_HEIGHT

export const LEADERBOARD_HEADER_HEIGHT = STANDARD_HEADER_HEIGHT

/** Shared sizing for screen and full-screen modal navigation rows. */
export const COMPACT_HEADER_STYLE = {
  height: STANDARD_HEADER_HEIGHT,
  paddingVertical: 0,
  flexShrink: 0,
} as const

/** Ink (text/icon) colour per theme, for icon components that take a colour
 *  prop — e.g. the close ✕ on game sheets and drawers. */
export const INK_COLOR = { light: '#18170f', dark: '#e6e1c4' } as const
